<template>
<div class="chapter">
<div class="inner_page">
<div class="part" id="part01">
<div class="partHead" id="ph01">
<a id="page63">
</a><h2 class="partNumber" style="text-indent: 0%;"><a id="page63"><span class="xrefInternal"></span></a><a href="#/text/9780062018465_Contents#part_01"><span class="bold">PART I</span></a></h2>
<h2 class="partTitle" style="text-indent: 0%;"><a href="#/text/9780062018465_Contents#part_01"><span class="bold">T<span class="smallCaps1">HE</span> G<span class="smallCaps1">REAT</span> T<span class="smallCaps1">URN IN</span> G<span class="smallCaps1">ERMAN</span> L<span class="smallCaps1">IFE</span></span></a></h2></div>
<div class="partBody">
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062018465_Part_1.vue?d7bf9d52